import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'next/router'
import { PageLayout } from '../components/page-layout'
import { MainInner } from '../components/main-inner'
import { TaxReturns } from '../contents/tax-returns'
import { withAuth } from '../utils/with-auth'

function TaxReturnsPage (props) {
  return (
    <PageLayout title='Tax returns' url={props.router} env={props.env}>
      <mosaic-page-header icon='home' page-header-title='Tax returns'>
        <div id='btn-container' />
      </mosaic-page-header>
      <MainInner fluid>
        <mosaic-card class='rounded-0 border-0 w-100'>
          <mosaic-card-header class='pb-0' card-header-title='United Kingdom'></mosaic-card-header>
          <TaxReturns />
        </mosaic-card>
      </MainInner>
    </PageLayout>
  )
}

TaxReturnsPage.propTypes = {
  router: PropTypes.object,
  env: PropTypes.object
}

export default withRouter(withAuth(TaxReturnsPage))
